import { suffix } from "./handleUniqueFieldName";

export { default as getName } from "./getName";
export { default as getFields } from "./getFields";
export { default as getFieldsV2 } from "./getFieldsV2";
export { default as getInitialValues } from "./getInitialValues";
export { default as getInputType } from "./getInputType";
export { default as validate } from "./validate";
export { default as validateV2 } from "./validateV2";
export { makeBuildSchema, makeSchemaV2 } from "./makeBuildSchema";

export const labelName1 = (str) => str.replace(/_/g, " ");
export const labelName = (str) =>{
  let name = str?.replace(/_/g, " ");
  name = name?.split(' ');
  if (name?.length > 1) {
    let lastItem = name[name.length - 1];
    if(Number(+lastItem)){
     name.pop();
    }
   return name.join(' ');
  }
  return name;
}

export const getDomain = () => {
  const hostname = window.location.hostname;
  const domain = hostname.split(".");
  return domain[0];
};
